
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressCreditCardsFR]",
      function () {
        return require("private-next-pages/[...wordpressCreditCardsFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressCreditCardsFR]"])
      });
    }
  